import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  .title {
    text-align: center;
  }

  .promotion-content {
    margin-top: 50px;
  }

  .button-block {
    display: flex;
    justify-content: center;
    margin-top: 58px;
    button {
      box-shadow: 0 0 20px 0 rgba(226, 64, 54, 0.2);
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .promotion-content {
      margin-top: 50px;

      .promotion-block {
        &:not(:last-child) {
          margin-bottom: 24px;
        }
      }
    }

    .button-block {
      margin-top: 40px;
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .promotion-content {
      margin-top: 30px;
    }

    .button-block {
      margin-top: 30px;
    }
  }
`
